import React, { useEffect, useState } from "react";
import axios from 'axios';
import CandidateNavbar from '../Candidate Navbar/Navbar';
import { useNavigate } from "react-router-dom";
import './Candidate_Dashboard.css'
 import LoadingSpinner from '../../Utils/LoadingSpinner'
 import { toast } from 'react-toastify';
 import Moment from 'react-moment';
 import ErrorPage from "../../Utils/Error_Page";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faLocationDot } from '@fortawesome/free-solid-svg-icons'
import {   faCalendarDays } from '@fortawesome/free-solid-svg-icons'
import {   faBuilding } from '@fortawesome/free-solid-svg-icons'




function CandidateDashboard(props) {
    var todayDate  = new Date();
    const navigate = useNavigate();
    const [loader,setLoader] = useState(true);
    const [job_fair, setJob_Fair] = useState(
        [{
            id: null,
            title: null,
            Description: null,
            total_company: null,
            registration_enddate: null,
            jobfair_startdate: null,
            jobfair_enddate: null,
            status: null,
            jobfair_starttime: null,
            jobfair_endtime: null,
            attachment: null,
            venue:null,
            total_companies:0,
            is_Applied:false
        }
    ]
    );
  
    

    useEffect(() => {
        const user = localStorage.getItem("user");
       
        if(user === null){
            localStorage.removeItem("user");
            navigate('/Candidate_Login');
        }else{
            let userId = JSON.parse(user)[0].id;
            axios.get(`https://pl.aspireitacademy.com/jobseeker_attempted_jobfair/${userId}`).then((response) => {
                setJob_Fair(response.data);
                setLoader(false);
                
            }).catch(error => {
                setLoader(false);
                navigate('/Error_Page');
              });
        }
        

    }, []);




    const doSelect = (item) => {
        const selectedItem = job_fair.find((data) => data.id === item.id);
        navigate('/Candidate_Company_list', {
            state: { selectedItem }
        });
    }
    
    return ( 
    <section  >           
    <CandidateNavbar />
    { loader ? <LoadingSpinner />: 
    <div className='container' >
    <div className="box mt-5">
    <div className="row" style={{justifyContent: "flex-start"}}>
    { job_fair.length === 0?
     <div className="container h-100 d-flex justify-content-center align-items-center">
        <div className="card p-5">
            <div className="card-body text-center">
                <h4 className="card-title">Welcome to Placement Plus</h4>
                <h6 className="card-text" style={{ height: "50px" }}>Currently, there is no active job fair listed.</h6>    
            </div>
        </div>
     </div>:
    job_fair.map((item) => {
        return (
                
            <div className="col-lg-4 col-md-4 gy-4 " key={item.id}>
                
                <div className="card card-job h-100">
                    <div className="card-header  card-header-jobfair" style={{borderBottom:"none",backgroundColor:"#f5f5f5"}} >
                        <h5 className="text-capitalize">{item.title}</h5> 
                    </div>
                    <div className="card-body">
                        <p className="card-text  mb-3 text-capitalize">
                       <FontAwesomeIcon  className="jobfair-icons" icon={faLocationDot} />  <span className="ms-2">{item.venue}</span></p>
                        <p className="card-text mb-3">
                       <FontAwesomeIcon  className="jobfair-icons" icon={faCalendarDays} />  <span className="ms-2"> 
                                Last Date to Apply: <Moment date={item.registration_enddate}
                                                     format="DD/MM/YYYY"  /></span></p>

                        <p className="card-text mb-3">
                       <FontAwesomeIcon  className="jobfair-icons" icon={faCalendarDays} />  <span className="ms-2">
                                Job Fair Starting date: <Moment date={item.jobfair_startdate}
                                                     format="DD/MM/YYYY"  /></span></p>
                        <p className="card-text mb-3">
                       <FontAwesomeIcon  className="jobfair-icons" icon={faCalendarDays} /> <span className="ms-2">
                                             Job Fair End date: <Moment date={item.jobfair_enddate}
                                                     format="DD/MM/YYYY"  /></span></p>
                        <p className="card-text mb-2">
                        <FontAwesomeIcon  className="jobfair-icons" icon={faBuilding} /> <span className="ms-2"> Total no. of Companies: {item.total_companies}</span></p>                                   </div>	
                        <div className="card-footer d-flex align-items-center " style={{borderTop:"none", backgroundColor:"#fff"}} >
                        <button type="button" onClick={() => doSelect(item)} className="btn btn-primary btn-apply">
                        {item.is_Applied === "True"?"View Details":
                         todayDate > new Date(item.registration_enddate)?"View Details":"Apply Now" 
                        }
                        </button>
                        
                        {
                           item.is_Applied === "True" ? <span className="alert alert-success" role="alert" >Applied</span>:
                           todayDate > new Date(item.registration_enddate)?<span className="alert alert-danger" role="alert" >Expired</span>:''
                        } 
                    </div>
                </div>
            </div>
                
                )
            })

        }
            </div>
    </div>
</div> 
        }
            <br/>
    
        </section>
        
    )
}

export default CandidateDashboard;